




























import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import { DateTime } from 'luxon';
import { DateHelper } from '@getaccept/lib-shared/src/helpers/date.helper';
import { DocumentStatus } from '@getaccept/lib-shared/src/enums/document-status';
import { ParagraphSize } from '@getaccept/lib-ui';
import type { DashboardActivity } from '../../../types/dashboard-activity';
import { DashboardEventName } from '../../../types/enums/dashboard-event-name';

export default defineComponent({
  name: 'LatestActivitiesWidgetItem',
  props: {
    activity: {
      type: Object as PropType<DashboardActivity>,
      default: null,
    },
  },
  setup(props) {
    const icon = computed(() => {
      switch (props.activity.eventName) {
        case DashboardEventName.Signed:
          return 'check-circle';
        case DashboardEventName.Commented:
          return 'chat-bubble';
        case DashboardEventName.Viewed:
          return 'view';
        case DashboardEventName.Rejected:
          return 'close-circle';
        case DashboardEventName.Downloaded:
          return 'download';
        case DashboardEventName.Printed:
          return 'print';
        case DashboardEventName.Reviewed:
          return 'document-check';
        case DashboardEventName.Forwarded:
          return 'forward-circle';
        default:
          return '';
      }
    });
    const date = computed(() =>
      /*Because of the format of the BE date, we need to convert it to local time this way. 
     once the endpoint is rewritten, the format returned should be aligned with current behavior*/
      DateTime.fromFormat(props.activity.createdAt, 'yyyy-MM-dd hh:mm:ss', { zone: 'utc' }).setZone(
        'local'
      )
    );

    const shortDate = computed(() => {
      if (!props.activity.createdAt) {
        return '';
      }
      return DateHelper.formattedDate(date.value);
    });

    const longDate = computed(() => {
      if (!props.activity.createdAt) {
        return '';
      }
      return date.value.toLocaleString({ ...DateTime.DATETIME_MED });
    });

    const tooltip = {
      triggers: ['hover', 'touch', 'focus'],
      content: longDate.value,
      offset: 6,
      boundariesElement: document.body,
    };

    const url = computed(() =>
      [DocumentStatus.Draft, DocumentStatus.Importing].includes(props.activity.documentStatus)
        ? `/document/edit/${props.activity.documentId}`
        : `/document/view/${props.activity.documentId}`
    );

    const activityOwner = computed((): string => {
      const { firstName, lastName, email, mobile, phone } = props.activity;
      if (firstName && lastName) {
        return `${firstName} ${lastName}`.trim();
      }

      if (email) {
        return email.trim();
      }

      return mobile.trim() || phone.trim();
    });

    return {
      icon,
      date,
      shortDate,
      longDate,
      tooltip,
      url,
      ParagraphSize,
      activityOwner,
      isToday: DateHelper.isToday(date.value),
    };
  },
});
